import { Box, Typography } from '@mui/material'
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined'
import DataSaverOffOutlinedIcon from '@mui/icons-material/DataSaverOffOutlined'
import './status.scss'
import { useTranslation } from 'react-i18next'

export const StatusIndicator = ({ type, color, size = '1.75rem', variant = 'h4' }) => {
  const { t } = useTranslation(['common'])
  const boxStyle = { display: 'flex', alignItems: 'center', gap: '.25rem' }

  // Define colors based on status type if not provided
  const getStatusColor = () => {
    if (color) return color

    switch (type) {
      case 'PROCESSED':
      case 'APPROVED':
      case 'ACTIVE':
      case 'COMPLETED':
        return '#2e7d32' // green
      case 'IN_PROGRESS':
      case 'PENDING':
      case 'CREATED':
        return '#ed6c02' // orange
      case 'DENIED':
      case 'CANCELED':
      case 'BLOCKED':
      case 'TERMINATED':
      case 'UNACCEPTABLE':
        return '#d32f2f' // red
      case 'NOT_STARTED':
      case 'DORMANT':
      case 'SUSPENDED':
        return '#66766B' // gray
      default:
        return '#66766B' // gray
    }
  }

  const statusColor = getStatusColor()
  const iconStyle = { color: statusColor, width: size, height: size }

  switch (type) {
    case 'DENIED':
      return (
        <Box sx={boxStyle}>
          <RemoveCircleOutlineOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>
            {t('common:denied')}
          </Typography>
        </Box>
      )
    case 'NOT_STARTED':
      return (
        <Box sx={boxStyle}>
          <MoreTimeOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:notStarted')}</Typography>
        </Box>
      )
    case 'IN_PROGRESS':
      return (
        <Box sx={boxStyle}>
          <RotateRightOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>
            {t('common:inProgress')}
          </Typography>
        </Box>
      )
    case 'APPROVED':
      return (
        <Box sx={boxStyle}>
          <TaskAltOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>
            {t('common:approved')}
          </Typography>
        </Box>
      )
    case 'PROCESSED':
      return (
        <Box sx={boxStyle}>
          <TaskAltOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>
            {t('common:processed')}
          </Typography>
        </Box>
      )
    case 'PENDING':
      return (
        <Box sx={boxStyle}>
          <AccessTimeOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:pending')}</Typography>
        </Box>
      )
    case 'CANCELED':
      return (
        <Box sx={boxStyle}>
          <HighlightOffOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:canceled')}</Typography>
        </Box>
      )
    case 'COMPLETED':
      return (
        <Box sx={boxStyle}>
          <MoreTimeOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:completed')}</Typography>
        </Box>
      )
    case 'ACTIVE':
      return (
        <Box sx={boxStyle}>
          <TaskAltOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:active')}</Typography>
        </Box>
      )
    case 'BLOCKED':
      return (
        <Box sx={boxStyle}>
          <RemoveCircleOutlineOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:blocked')}</Typography>
        </Box>
      )
    case 'CREATED':
      return (
        <Box sx={boxStyle}>
          <AddCircleOutlineOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:created')}</Typography>
        </Box>
      )
    case 'DORMANT':
      return (
        <Box sx={boxStyle}>
          <HistoryToggleOffOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:dormant')}</Typography>
        </Box>
      )
    case 'SUSPENDED':
      return (
        <Box sx={boxStyle}>
          <PauseCircleOutlineOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:suspended')}</Typography>
        </Box>
      )
    case 'TERMINATED':
      return (
        <Box sx={boxStyle}>
          <DataSaverOffOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:terminated')}</Typography>
        </Box>
      )
    case 'UNACCEPTABLE':
      return (
        <Box sx={boxStyle}>
          <HighlightOffOutlinedIcon sx={iconStyle} />
          <Typography variant={variant} color={statusColor}>{t('common:unacceptable')}</Typography>
        </Box>
      )
    default:
      return
  }
}
